var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBarcodeDisabled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 13,
  viewBox: "0 0 20 13",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.55469 2H3.82741V11H2.55469V2ZM6.37287 2H7.00923V11H6.37287V2ZM4.46378 2H5.73651V11H4.46378V2ZM14.6456 2H16.5547V11H14.6456V2ZM8.28196 2H9.55469V11H8.28196V2ZM12.7365 2H13.3729V11H12.7365V2ZM10.1911 2H12.1001V11H10.1911V2Z",
  fill: "#F44336",
  fillOpacity: 0.32
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.554674 12L18.5547 -1.90735e-05L19.1094 0.832031L1.10937 12.832L0.554674 12Z",
  fill: "#F44336",
  fillOpacity: 0.32
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarcodeDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/barcode-disabled.180d7c68.svg";
export { ForwardRef as ReactComponent };